import { render, staticRenderFns } from "./Onboarding.view.vue?vue&type=template&id=1bfe687e&scoped=true&"
import script from "./Onboarding.view.vue?vue&type=script&lang=js&"
export * from "./Onboarding.view.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.view.vue?vue&type=style&index=0&id=1bfe687e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe687e",
  null
  
)

export default component.exports